var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formTitle"},[_c('span',{class:_vm.title.length>4?'longTitle':'title'},[_vm._v(_vm._s(_vm.title))]),(_vm.multipleChoice)?_c('div',{staticClass:"multipleChoice"},[_vm._v("多选项")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }